var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 47.5,
    fill: "white",
    stroke: "#ffffff",
    strokeWidth: 5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0404 72H74.9483C77.6193 72 79.793 69.5767 79.793 66.5982V32.4018C79.793 29.4372 77.6387 27.0274 74.985 27.0045C74.9765 27.004 74.9689 27 74.9608 27H74.9483H25.0404H25.028C25.0195 27 25.0119 27.004 25.0038 27.0045C22.3501 27.0274 20.1957 29.4372 20.1957 32.4018V66.5982C20.1949 69.5767 22.369 72 25.0404 72ZM25.5462 68.4L42.0559 48.4128L48.9152 55.3361C49.2217 55.6452 49.6074 55.8 49.9936 55.8C50.3802 55.8 50.7659 55.6452 51.0728 55.3361L57.9317 48.4128L74.4417 68.4H25.5462ZM75.4646 30.7156C76.1032 30.9582 76.5711 31.6111 76.5711 32.4013V65.6721L60.322 46.0003L75.4646 30.7156ZM70.7749 30.6L49.9936 51.574L29.2135 30.6H70.7749ZM23.4164 32.4018C23.4164 31.6116 23.8843 30.9587 24.523 30.7161L39.6655 46.0008L23.4164 65.6721V32.4018Z",
    fill: "rgb(54, 63, 73)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_18"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "translate(20 27)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoMail);
export default __webpack_public_path__ + "static/media/info_mail.fae82afec1dd5b55cd12d2a13e3e6f47.svg";
export { ForwardRef as ReactComponent };